import { randomUuid } from '@lemonade-hq/ts-helpers';
import { isNativeAndroid, postAndroidMessage } from './android';
import { postWebKitMessage } from './ios';
import type { Message, MessageResponse } from './types';
import { isNativeApp } from './utils';

export async function sendMessage<T extends Message, U extends MessageResponse['payload']>(
  messageObj: T,
): Promise<U | undefined> {
  const id = randomUuid();

  const controller = new AbortController();

  const isWeb = !isNativeApp();
  if (isWeb) return;

  const postMessage = isNativeAndroid() ? postAndroidMessage : postWebKitMessage;
  const message = JSON.stringify({ ...messageObj, id });

  postMessage(message);

  return await new Promise(resolve => {
    window.addEventListener(
      'message',
      event => {
        const data = JSON.parse(event.data as string) as MessageResponse;
        if (data.id === id) {
          resolve(data.payload as U);
          controller.abort();
        }
      },
      { signal: controller.signal },
    );
  });
}
